<template>
  <div class="aside-top-bar">
    <el-link type="primary" v-if="!menuCollapse" :underline="false" icon="fa fa-angle-double-left toggle-menu" title="收起菜单" @click="toggleMenu"></el-link>
    <el-link type="primary" v-if="menuCollapse" :underline="false" icon="fa fa-angle-double-right toggle-menu" title="展开菜单" @click="toggleMenu"></el-link>
    <el-tabs v-model="activeMenu" closable @tab-click="handleTabClick" @tab-remove="onTabRemove">
      <el-tab-pane v-for="menu in menus" :label="menu.menuName" :name="menu.menuId" :key="menu.menuId">
        <span slot="label"><i v-if="menu.icon" :class="menu.icon"></i> {{ menu.menuName }}</span>
      </el-tab-pane>
    </el-tabs>
    <el-link type="danger" title="关闭所有" :underline="false" icon="fa fa-times-circle-o" @click="closeAllTabs"></el-link>
    <div class="user-bar">
      <el-avatar size="small" src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"></el-avatar>
      <el-dropdown size="small" style="cursor: pointer">
        <span class="el-dropdown-link">
          {{ me?me.userName:"" }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="modifyPass">
            <i class="fa fa-pencil-square-o"></i>
            修改密码
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="quit()">
            <i class="fa fa-mail-reply"></i>
            退出
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import SessionStore from "@/utils/SessionStore";

export default {
  name: "AsideTopBar",
  extends: BaseVue,
  props: {
    menuCollapse: {
      default: false
    }
  },
  data() {
    return {
      me: null,
      activeMenu: '',
      menus: [{menuId:'home', menuName:'首页', icon:'fa fa-home', url: '/console'}]
    }
  },
  created() {
    let cache = this.getComponentCache();
    if(!!cache) {
      this.menus = cache.menus;
      this.activeMenu = cache.activeMenu;
    }
    this.getMe().then(dr=>{
      this.me = dr.bean;
      SessionStore.setUser(this.me);
    });
    if(document.location.href.split("#")[1] == "/") {
      this.activeMenu = "home"
      this.$router.push(this.menus[0].url);
    }
  },
  methods: {
    quit() {
      this.$confirm("确定要退出吗？", "系统提示", {type:'info'}).then(()=>{
        this.postForm("/login/v2/logout").then(()=>{
          this.clearComponentCache();
          this.$router.push("/login");
        });
      })
    },
    toggleMenu() {
      this.$emit("on-menu-collapse");
    },
    open(menu) {
      this.activeMenu = menu.menuId;
      let exist = false;
      for (let menu1 of this.menus) {
        if(menu.menuId == menu1.menuId) {
          exist = true;
          break;
        }
      }
      if(!exist) {
        this.menus.push(menu);
        this.saveCache();
      }
    },
    closeAllTabs(){
      this.menus.splice(1,this.menus.length);
      if(this.activeMenu !== this.menus[0].menuId) {
        this.activeMenu = this.menus[0].menuId;
        this.$router.push(this.menus[0].url);
      }
      this.saveCache();
    },
    handleTabClick() {
      this.menus.forEach((menu)=>{
        if(menu.menuId === this.activeMenu && this.$route.path != menu.url) {
          this.$router.push(menu.url);
          return;
        }
      });
    },
    onTabRemove(menuId) {
      if(menuId == "home") {
        return;
      }
      this.menus.forEach((menu,index)=>{
        if(menu.menuId === menuId) {
          let nextMenu = this.menus[index-1] || this.menus[index+1];
          this.menus.splice(index,1);
          this.activeMenu = nextMenu.menuId;
          this.$router.push(nextMenu.url);
          this.saveCache();
          return;
        }
      });
    },
    //保存缓存
    saveCache() {
      this.setComponentCache({
        menus: this.menus,
        activeMenu: this.activeMenu
      });
    },
    modifyPass() {
      this.$router.push("/modifyPass");
    }
  }
}
</script>

<style lang="scss">
@import "../../css/variables";
.aside-top-bar {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 2px solid #e6e6e6;
  .toggle-menu{
    padding: 0px 20px;
  }
  .fa-times-circle-o {
    cursor: pointer;
    padding: 0px 10px;
  }
  .el-tabs{
    width: calc(100vh - 200px);
    flex-grow: 1;
    &__header {
      margin-bottom: 0px;
    }
    &__item {
      height: 30px;
      line-height: 30px;
      border-bottom: 0px;
    }
    &__active-bar {
      height: 1px;
    }
    &__nav-wrap::after {
      height: 0px;
    }
    &__nav-next, &__nav-prev{
      line-height: 32px;
    }
  }
  .user-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 30px 0px 10px;
    .el-avatar {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }
}
</style>